import CallApp from 'callapp-lib';

function initCallApp() {
  const option = {
    scheme: {
      protocol: 'xluri'
    },
    appstore: 'itms-apps://itunes.apple.com/app/id1572970303',
    // yingyongbao: 'market://details?id=com.xiaolachuxing.driver',
    yingyongbao:
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaolachuxing.driver',
    timeout: 2000
  };
  if (!window.CallApp) {
    window.CallApp = new CallApp(option);
  }
}
initCallApp();
export const lib = window.CallApp;
export function evokeByLocation(uri) {
  window.location.href = uri;
}
export function evokeByTagA(uri) {
  const tagA = document.createElement('a');

  tagA.setAttribute('href', uri);
  tagA.style.display = 'none';
  document.body.append(tagA);

  tagA.click();
}
